import { render, staticRenderFns } from "./show_supply.vue?vue&type=template&id=049a6c95&"
import script from "./show_supply.vue?vue&type=script&lang=js&"
export * from "./show_supply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports